// src/components/admin/StaffCommsModal.jsx
// ----------------------------------------
// Opens the Communications module in "Zephyr Staff" audience mode inside a
// non-draggable modal, launched from Manage → Zephyr Staff. Reuses the whole CRM
// shell (Compose / Audience / Review & send / History) via CrmShell audience="staff";
// CrmShell is lazy-loaded so its bundle (incl. the rich-text editor) only downloads
// when the modal is opened. Runs inside the main app's existing session.

import React from "react";
import { ModalBackdrop } from "../form/FormUI.jsx";

const CrmShell = React.lazy(() =>
  import("../../crm/CrmShell.jsx").then((m) => ({ default: m.CrmShell }))
);

export function StaffCommsModal({ onClose }) {
  return (
    <ModalBackdrop
      onClose={onClose}
      portal
      contentStyle={{
        background: "#f5f5f5",
        borderRadius: 12,
        padding: 0,
        width: "min(1150px, calc(100vw - 40px))",
        maxHeight: "92vh",
        overflow: "auto",
      }}
    >
      <div style={{ position: "relative" }}>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: 14,
            right: 14,
            zIndex: 2,
            width: 30,
            height: 30,
            background: "rgba(255,255,255,0.2)",
            border: "none",
            color: "white",
            fontSize: 22,
            lineHeight: 1,
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          ×
        </button>
        <React.Suspense fallback={<div style={{ padding: 40, color: "#607D79" }}>Loading…</div>}>
          <CrmShell audienceMode="staff" />
        </React.Suspense>
      </div>
    </ModalBackdrop>
  );
}
